export const queryKeys = {
  GET_ASSIGN_INFO: "GET_ASSIGN_INFO",
  LEAD_EMPLOYEE: "LEAD_EMPLOYEE"
}